import { Button } from "@tellescope/design-system";
import { useTranslation } from "react-i18next";
import { ZoomIn, ZoomOut } from "lucide-react";

interface PdfZoomControlsProps {
  zoomPercent: number;
  canZoomIn: boolean;
  canZoomOut: boolean;
  zoomIn: () => void;
  zoomOut: () => void;
  resetZoom: () => void;
}

export const PdfZoomControls = ({
  zoomPercent,
  canZoomIn,
  canZoomOut,
  zoomIn,
  zoomOut,
  resetZoom,
}: PdfZoomControlsProps) => {
  const { t } = useTranslation("files");

  return (
    <div className="flex justify-end">
      <Button.Group>
        <Button
          variant="outline"
          color="muted"
          size="sm"
          iconOnly
          hoverLabel={t("Zoom out")}
          disabled={!canZoomOut}
          onClick={zoomOut}
        >
          <ZoomOut />
        </Button>
        <Button
          variant="outline"
          color="muted"
          size="sm"
          hoverLabel={t("Reset zoom")}
          disabled={zoomPercent === 100}
          onClick={resetZoom}
          className="min-w-16 tabular-nums"
        >
          {t("{{percent}}%", { percent: zoomPercent })}
        </Button>
        <Button
          variant="outline"
          color="muted"
          size="sm"
          iconOnly
          hoverLabel={t("Zoom in")}
          disabled={!canZoomIn}
          onClick={zoomIn}
        >
          <ZoomIn />
        </Button>
      </Button.Group>
    </div>
  );
};
